import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostListener,
  Input,
  Output,
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-novo-relato',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule],
  templateUrl: './novo-relato.component.html',
  styleUrls: ['./novo-relato.component.scss'],
})
export class NovoRelatoComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  @Input() idObra: number | null = null;
  @Input() moduloId: number | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() relatoCriado = new EventEmitter<any>();
  @Output() loading = new EventEmitter<boolean>();

  userId: string;

  descricaoRelato = '';
  nomeRelato = '';
  autorRelato = '';
  responsavel: any[] = [];
  selectedResponsaveis: any[] = [];
  dropdownOpen = false;

  responsavelSelecionados: any[] = [];

  enviarEmail = false;
  sucessoRelato: boolean = false; 

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const dropdown = document.querySelector('.dropdown-multiselect');

    if (dropdown && !dropdown.contains(target)) {
      this.dropdownOpen = false;
    }
  }

  constructor(private fichaDaObraService: FichaDaObraService) {
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit(): void {
    this.sucessoRelato = false;
    this.popularResponsavel();

  }

  ngOnDestroy(): void {}

  clear() {
    this.descricaoRelato = '';
    this.nomeRelato = '';
    this.enviarEmail = false;
    this.selectedResponsaveis = [];
  }

  criarRelato() {
    this.loading.emit(true);
    if (!this.idObra) {
      console.error('idObra não informado');
      return;
    }

    let textTypeID = 1;
    let sendEmailContactIDs: string | null = null;

    if (this.enviarEmail && this.selectedResponsaveis.length > 0) {
      textTypeID = 2;

      sendEmailContactIDs = this.selectedResponsaveis
        .map((r: any) => r.id)
        .join(',');
    }

    const body: any = {
      textTypeID,
      title: this.nomeRelato,
      text: this.descricaoRelato,
      sendEmailContactIDs: sendEmailContactIDs,
      isEdited: false,
      reportID: 0
    };

    this.fichaDaObraService.novoRelato(this.idObra, body, this.moduloId).subscribe({
      next: (res) => {
        this.loading.emit(false);
        this.relatoCriado.emit();
        this.sucessoRelato = true;
      },
      error: (err) => {
        this.loading.emit(false);
        console.error('Erro ao criar relato:', err);
      },
    });
  }

  continuar() {
    this.sucessoRelato = false;
    this.close.emit();
  }

  popularResponsavel(): void {
    this.fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
      this.responsavel = response.data.sort((a, b) =>
          a.name.localeCompare(b.name)
        );
      },
      (error) => {
        console.error('Erro ao buscar responsáveis:', error);
      }
    );
  }

  toggleDropdown() {
    if (this.enviarEmail) {
      this.dropdownOpen = !this.dropdownOpen;
    }
  }
  isSelected(responsavel: any): boolean {
    return this.selectedResponsaveis.some((r) => r.id === responsavel.id);
  }

  toggleSelection(responsavel: any) {
    if (this.isSelected(responsavel)) {
      this.selectedResponsaveis = this.selectedResponsaveis.filter(
        (r) => r.id !== responsavel.id
      );
    } else {
      this.selectedResponsaveis.push(responsavel);
    }
  }

  isAllSelected(): boolean {
    return (
      this.responsavel.length > 0 &&
      this.selectedResponsaveis.length === this.responsavel.length
    );
  }

  toggleSelectAll(event: any) {
    if (event.target.checked) {
      this.selectedResponsaveis = [...this.responsavel];
    } else {
      this.selectedResponsaveis = [];
    }
  }

  getResponsaveisSelecionadosNomes(): string {
    if (
      this.selectedResponsaveis.length === this.responsavel.length &&
      this.responsavel.length > 0
    ) {
      return 'Todos os contatos selecionados';
    }
    return this.selectedResponsaveis.map((r) => r.name).join(', ');
  }
}
